import type { AuditEventPage } from '../identity/types';
import {
  accountingApiBaseUrl,
  compensationApiBaseUrl,
  customPayRunApiBaseUrl,
  employeesApiBaseUrl,
  paymentProcessingApiBaseUrl,
  payrollCalculationApiBaseUrl,
  payrollConfigApiBaseUrl,
  payrollRunApiBaseUrl,
  dashboardApiBaseUrl,
  reportsApiBaseUrl,
  subscriptionsApiBaseUrl,
  taxComplianceApiBaseUrl,
  taxFormsApiBaseUrl,
  timeAndLeaveApiBaseUrl,
} from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { AuditHistoryGateway, ModuleAuditEvent } from './AuditHistoryGateway';

const MODULES: { name: string; request: <T>(path: string, init?: RequestInit, signal?: AbortSignal) => Promise<T> }[] = [
  { name: 'Identity', request: createJsonClient('') },
  { name: 'People', request: createJsonClient(employeesApiBaseUrl) },
  { name: 'Payroll Configuration', request: createJsonClient(payrollConfigApiBaseUrl) },
  { name: 'Compensation', request: createJsonClient(compensationApiBaseUrl) },
  { name: 'Time & Leave', request: createJsonClient(timeAndLeaveApiBaseUrl) },
  { name: 'Payroll Calculation', request: createJsonClient(payrollCalculationApiBaseUrl) },
  { name: 'Payroll Review', request: createJsonClient(payrollRunApiBaseUrl) },
  { name: 'Custom Pay Run', request: createJsonClient(customPayRunApiBaseUrl) },
  { name: 'Payment Processing', request: createJsonClient(paymentProcessingApiBaseUrl) },
  { name: 'Tax Compliance', request: createJsonClient(taxComplianceApiBaseUrl) },
  { name: 'Tax Forms', request: createJsonClient(taxFormsApiBaseUrl) },
  { name: 'Accounting', request: createJsonClient(accountingApiBaseUrl) },
  { name: 'Reports', request: createJsonClient(reportsApiBaseUrl) },
  { name: 'Subscriptions', request: createJsonClient(subscriptionsApiBaseUrl) },
  { name: 'Dashboard', request: createJsonClient(dashboardApiBaseUrl) },
];

export class HttpAuditHistoryGateway implements AuditHistoryGateway {
  async getRecentAcrossModules(pageSize: number, signal?: AbortSignal): Promise<ModuleAuditEvent[]> {
    const results = await Promise.allSettled(
      MODULES.map(async (m) => {
        const page = await m.request<AuditEventPage>(`/api/audit-events?page=1&pageSize=${pageSize}`, undefined, signal);
        return page.items.map((item): ModuleAuditEvent => ({ ...item, module: m.name }));
      }),
    );

    return results
      .filter((r): r is PromiseFulfilledResult<ModuleAuditEvent[]> => r.status === 'fulfilled')
      .flatMap((r) => r.value)
      .sort((a, b) => new Date(b.occurredAtUtc).getTime() - new Date(a.occurredAtUtc).getTime())
      .slice(0, pageSize);
  }
}
